// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown-toggle:after{content:normal}#more{display:none}.content--description a,.content--description a:hover{color:#ff0d00}.content--description p{margin-bottom:0}.content--description__showreadmore{background:none;border:none;bottom:0;float:right;font-style:italic}.searchbox{max-width:100vw!important;width:auto!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
